import { h } from '@stencil/core/internal/client';

const ButtonSpinner = () => (h("div", { class: "spinner-border spinner-border-sm", role: "status", part: "button-spinner" },
    h("span", { class: "visually-hidden" }, "Loading...")));

const Button = (props, children) => {
    const classMap = {
        primary: 'btn btn-primary',
        secondary: 'btn btn-secondary',
    };
    const exportPartMapping = {
        primary: ['button', 'button-primary'],
        secondary: ['button', 'button-secondary'],
    };
    const getCSSParts = () => {
        const baseCSSParts = exportPartMapping[props.variant];
        if (props.isLoading)
            baseCSSParts.push('button-loading');
        return baseCSSParts.join(' ');
    };
    return (h("button", Object.assign({ class: classMap[props.variant], onClick: props.clickHandler, part: getCSSParts() }, props), props.isLoading ? ButtonSpinner() : children));
};

export { Button as B };
